import React from 'react';
import { LinearProgress, makeStyles } from '@material-ui/core';
import { AccessTime } from '@material-ui/icons';

const useStyles = makeStyles({
  kpiProgress: {
    textAlign: 'center'
  },
  kpiProgressLine: {
    position: 'relative'
  },
  kpiProrate: {
    color: '#666',
    position: 'absolute',
    top: -2
  },
  prorateIndicator: {
    height: 8,
    width: 2
  },
  kpiProrateInfo: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    opacity: 0.8
  },
  prorateIcon: {
    height: 16,
    width: 16
  }
}, { name: 'KPIProrate' });

const KPIProgressIndicator = ({
  progress,
  prorate,
  showValue  = true
}) => {
  const classes = useStyles();

  return (
    <div className={ classes.kpiProgress }>
      <div>{ `${progress}%` }</div>
      <div className={ classes.kpiProgressLine }>
        <LinearProgress
          variant='determinate'
          value={ progress > 100 ? 100 : progress }
        />
        <div className={ classes.kpiProrate } style={ { left: `${prorate}%` } }>
          <div
            className={ classes.prorateIndicator }
            style={ {
              background: prorate > progress ? 'red' : '#666'
            } }
          />
          <div className={ classes.kpiProrateInfo }>
            <AccessTime className={ classes.prorateIcon } />
            {showValue && `${prorate || 0}%`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KPIProgressIndicator;